import Vue from "vue";
import VueI18n from "vue-i18n";
import gb from "./locales/gb";
import es from "./locales/es";
import az from "./locales/az";
import ru from "./locales/ru";
import tr from "./locales/tr";
import th from "./locales/th";

Vue.use(VueI18n);

const locales = ["gb", "es", "az", "ru", "tr", "th"];

export const appLanguage = () => {
  const navigatorLanguage = navigator.language?.split("-")[0];
  const browserLanguage = locales.includes(navigatorLanguage)
    ? navigatorLanguage
    : "gb";

  return localStorage.getItem("language") || browserLanguage;
};

export const messages = {
  es,
  gb,
  az,
  ru,
  tr,
  th
};

export default new VueI18n({
  messages,
  locale: appLanguage(),
  fallbackLocale: "gb",
  silentFallbackWarn: true
});
